var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH675(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#cecece;stroke-dasharray:0 0 0 8.5;stroke-width:5.67px;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#ffdf97;}.cls-4{fill:#ea8b49;}.cls-5,.cls-6{fill:#fff;}.cls-7{fill:#ffefcf;}.cls-8{fill:#ffbf57;}.cls-9{fill:#efecea;}.cls-10{fill:#d37a3d;}.cls-11{fill:#6dd3ce;}.cls-6{opacity:0;}.cls-2{stroke:#ffd15c;stroke-width:8.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 30.58,
    y: 104.59,
    width: 29.28,
    height: 16.97,
    rx: 3.44,
    ry: 3.44,
    transform: "translate(93.2 1.14) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 37.03,
    y: 99.16,
    width: 46.04,
    height: 16.39,
    rx: 3.37,
    ry: 3.37,
    transform: "translate(178.43 140.8) rotate(135)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.51,79.22c3.53-4.44,22.54-26.12,58.08-27.21,2.35-.07,4.11,2.13,3.48,4.39-3.81,13.7-15.25,55.19-17.09,65.44-.24,1.32-1.2,2.38-2.5,2.73l-44.79,12.23c-2.38,.65-4.65-1.32-4.35-3.77l6.45-52.1c.08-.63,.32-1.23,.72-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M107.85,78.92c-2.26-3.36-10.67-12.12-39.58-19.12-2.75-.67-5.33,1.62-4.99,4.43,1.51,12.7,4.99,42.82,4.98,51.55,0,1.43,.74,2.76,1.96,3.49l26.6,16.04c2.54,1.53,5.81-.09,6.13-3.04l5.53-50.7c.1-.93-.11-1.87-.63-2.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.09,124.62c-16.64,43.62-74.78,55.96-107.68,22.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.19,114.33c-.15,.69-.31,1.38-.48,2.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.14,62.13c37.56-51.48,118.13-25.89,119.5,37.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.38,71.82c.29-.61,.6-1.21,.91-1.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M136.59,29.81c-2.18,0-3.95-2.82-3.95-4.14,0-.22-.47-.22-.47,0,0,1.27-1.63,4.14-4.2,4.14-.22,0-.22,.47,0,.47,2.24,0,4.2,3.07,4.2,4.14,0,.22,.47,.22,.47,0,0-1.27,1.82-4.14,3.95-4.14,.22,0,.22-.47,0-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.22,48.38c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M47.56,136.81c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.89,63.71c3.53-4.44,20.47-27.09,56.01-28.18,2.35-.07,7.98,6.78,7.35,9.04-3.81,13.7-14.67,53.13-16.52,63.38-.24,1.32-1.2,2.38-2.5,2.73l-44.79,12.23c-2.38,.65-4.65-1.32-4.35-3.77l6.45-52.1c.08-.63-2.04-2.84-1.65-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.01,64.28c-2.91-3.04-10.51-13.86-35.87-20.51-2.74-.72-10.39,5.43-10.05,8.24,1.51,12.7,5.68,40.92,5.67,49.65,0,1.43,.74,2.76,1.96,3.49l26.6,16.04c2.54,1.53,5.81-.09,6.13-3.04l5.53-50.7c.1-.93,.67-2.5,.02-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.56,68.26c3.53-4.44,22.54-26.12,58.08-27.21,2.35-.07,4.11,2.13,3.48,4.39-3.81,13.7-15.25,55.19-17.09,65.44-.24,1.32-1.2,2.38-2.5,2.73l-44.79,12.23c-2.38,.65-4.65-1.32-4.35-3.77l6.45-52.1c.08-.63,.32-1.23,.72-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.65,67.74c-2.26-3.36-10.67-12.12-39.58-19.12-2.75-.67-5.33,1.62-4.99,4.43,1.51,12.7,4.99,42.82,4.98,51.55,0,1.43,.74,2.76,1.96,3.49l26.6,16.04c2.54,1.53,5.81-.09,6.13-3.04l5.53-50.7c.1-.93-.11-1.87-.63-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.33,94.61c3.37-1.64,13.69-6.06,30.13-8,.5-.06,.89,.45,.71,.92l-1.41,3.54c-.39,.97-1.24,1.68-2.26,1.88-5.18,1.01-21.35,4.42-29.25,9.29-.52,.32-1.16-.18-.98-.76l1.48-4.98c.24-.82,.82-1.51,1.59-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M116.28,102.42c1.95-.95,7.92-3.51,17.43-4.63,.29-.03,.52,.26,.41,.53l-.82,2.05c-.22,.56-.72,.97-1.31,1.09-3,.58-12.35,2.56-16.92,5.38-.3,.19-.67-.1-.57-.44l.86-2.88c.14-.48,.47-.87,.92-1.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.38,75.51c-2.34-2.95-2.89-11.8-2.89-11.8l-3.66,1.05s-5.21,10.05-8.98,14.18l-1.05,1.15c-.11,2.38,2.97,2.6,7.32,1.77,4.58-.93,8.62-2.63,9.95-5.49l-.69-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.54,74.53c-1.29-1.53-1.71-5.59-1.71-5.59l-1.7,.44s-2.74,4.77-4.95,7.06l-.66,.68c-.24,1.46,1.51,1.6,4.01,1.08,2.58-.58,4.78-1.59,5.39-3.21l-.4-.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 24.17,
    y: 96.22,
    width: 29.28,
    height: 16.97,
    rx: 3.44,
    ry: 3.44,
    transform: "translate(85.41 3.23) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 30.62,
    y: 90.79,
    width: 46.04,
    height: 16.39,
    rx: 3.37,
    ry: 3.37,
    transform: "translate(161.57 131.04) rotate(135)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 64.01,
    cy: 83.76,
    r: 1.94
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.13,123.05c-8.23,16.48-37.5,43.08-76.7,6.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH675);
export default __webpack_public_path__ + "static/media/H67-5.c32e8fc51fcbac61779611a764ad18f2.svg";
export { ForwardRef as ReactComponent };